import React, { ChangeEvent, TextareaHTMLAttributes } from 'react';

import PropTypes from 'prop-types';

import Textarea from '@adsk/alloy-react-textarea';
import {
  stylePropType,
  DetailedStylableComponent,
} from '@adsk/alloy-react-theme';

type CommentInputProps = Omit<
  DetailedStylableComponent<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >,
  'onChange' | 'ref' | 'onBlur' | 'onFocus'
> & {
  onBlur: (event: React.ChangeEvent) => void;
  onChange: (value: string) => void;
  onFocus: () => void;
  focused?: boolean;
  error?: string;
  value: string;
};

const CommentInput = React.forwardRef<HTMLTextAreaElement, CommentInputProps>(
  ({ style, className, onChange, error, ...props }, ref) => {
    return (
      <Textarea
        ref={ref}
        style={style}
        className={className}
        onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
          onChange(e.target.value)
        }
        error={!!error}
        {...props}
      />
    );
  },
);

CommentInput.displayName = 'CommentInput';

CommentInput.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /* The comment text */
  value: PropTypes.string.isRequired,
  /* Triggers on input change */
  onChange: PropTypes.func.isRequired,
  /* Triggers on input focus */
  onFocus: PropTypes.func.isRequired,
  /* Triggers on input blur */
  onBlur: PropTypes.func.isRequired,
  /* Is input in error state */
  error: PropTypes.string,
};

export default CommentInput;
